import { type IFileType, isFileVideo } from "./fileHelpers";
import type { VideoMetaData } from "./types/INodeDefinition";

export const getVideoMetadataFromFile = async (file?: IFileType): Promise<VideoMetaData | null> => {
	if (!file) return null;

	if (!isFileVideo(file)) return null;

	if (file.videoWidth && file.videoHeight && file.duration) {
		return {
			width: file.videoWidth,
			height: file.videoHeight,
			duration: file.duration
		};
	}

	return await extractVideoMetadata(file);
};

const extractVideoMetadata = async (file: IFileType): Promise<VideoMetaData | null> => {
	return new Promise((resolve) => {
		const url = URL.createObjectURL(file);
		const video = document.createElement("video");

		video.onloadedmetadata = () => {
			const metadata: VideoMetaData = {
				width: video.videoWidth,
				height: video.videoHeight,
				duration: video.duration
			};

			video.onloadedmetadata = null;
			video.onerror = null;

			URL.revokeObjectURL(url);
			video.remove();
			resolve(metadata);
		};

		video.onerror = () => {
			video.onloadedmetadata = null;
			video.onerror = null;

			URL.revokeObjectURL(url);
			video.remove();
			resolve(null);
		};

		video.src = url;
		video.load();
	});
};
